import StructureFormSelectorHtml from "./StructureFormSelectorHtml.js";
import {assertNotNull} from "../../js/util/CommonUtils.js";

export default class StructureFormSelectorCmp {
    #html = new StructureFormSelectorHtml(this.#onOk.bind(this));
    /** @type {StructureId} */
    #structureId;
    /** @type {StructureForms} */
    #forms;
    /** @type {StructRepository} */
    #structRepo;
    /** @type {Function} */
    #onOkCb = ()=>{};

    /**
     * @param {StructRepository} structRepo
     * @param {StructureId} structureId
     * @param {StructureForms} forms
     */
    constructor(structRepo, structureId, forms) {
        this.#structureId = assertNotNull(structureId);
        this.#structRepo = assertNotNull(structRepo); // TODO why repo is here?
        this.#forms = assertNotNull(forms);
    }

    show() {
        this.#html.show(this.#forms);
    }

    onOk(cb) {
        this.#onOkCb = cb;
    }

    /**
     * @param {{stereo: boolean, protonation: boolean}} optionsSelected
     */
    #onOk(optionsSelected) {
        this.#onOkCb(this.#structureId, this.#forms.withSelectedOptions(optionsSelected));
    }
}